<template>
  <v-card>
    <v-card-title>Forgot Password</v-card-title>
    <v-card-text>
      <div class="reset-email-code">
        <v-text-field
          prepend-icon="email"
          label="Your Email"
          type="text"
          name="email"
          v-model="data.email"
          :rules="[rules.verifyEmail]"
          :disabled="emailDisable"
        ></v-text-field>
        <v-btn @click="sendEmail">
          send email
        </v-btn>
      </div>
      <div class="reset-email-code">
        <v-text-field
          prepend-icon="drafts"
          label="captcha"
          type="text"
          name="captcha"
          v-model="data.captcha"
        ></v-text-field>
      </div>
      <div class="reset-email-code">
        <v-text-field
          prepend-icon="arrow_forward"
          label="New Password"
          type="password"
          :rules="[rules.min]"
          v-model="data.password"
          :disabled="passwordDisable"
        ></v-text-field>
      </div>
      <div class="reset-email-code">
        <v-text-field
          prepend-icon="arrow_forward"
          label="Please enter again"
          type="password"
          v-model="data.ensurePassword"
          :disabled="passwordDisable"
        ></v-text-field>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="save" :disabled="saveDisable">
        Save
      </v-btn>
      <v-btn color="blue darken-1" text @click="hideDialog">
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AuthApi } from '@/api/pandaria'
import { Tool, Cache, Crypto } from '@/util/index'

const cache = new Cache()
const tool = new Tool()
export default {
  name: 'forgot-pass-card',
  data () {
    return {
      layoutData: {
        isLoading: false
      },
      data: {
        email: '',
        captcha: '',
        password: '',
        ensurePassword: ''
      },
      passwordDisable: true,
      emailDisable: false,
      saveDisable: true,
      rules: {
        verifyEmail: function (value) {
          // eslint-disable-next-line no-useless-escape
          const reg = /^[A-Za-z0-9]+([_.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/
          if (reg.test(value)) {
            return true
          } else {
            return 'Please enter the correct email'
          }
        },
        min: function (value) {
          const regex = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,18}$')
          if (value.length < 8) {
            return 'Min 8 characters'
          } else if (value.length > 18) {
            return 'Max 18 characters'
          } else if (!regex.test(value) && value.length >= 8 && value.length <= 18) {
            return 'The password must contain uppercase letters, lowercase letters, numbers, special characters'
          } else {
            return true
          }
        }
      },
      compareText: ''
    }
  },
  watch: {
    data: {
      handler: function () {
        this.saveDisable = !(tool.isNotEmpty(this.data.captcha) && tool.isNotEmpty(this.data.password) && tool.isNotEmpty(this.data.ensurePassword) && this.rules.min(this.data.password))
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    hideDialog () {
      this.data.email = ''
      this.data.captcha = ''
      this.data.password = ''
      this.data.ensurePassword = ''
      this.passwordDisable = true
      this.emailDisable = false
      this.saveDisable = true
      this.$emit('hideDialog')
    },
    sendEmail () {
      const $this = this
      if (tool.isEmpty(this.data.email)) {
        $this.$swal({ type: 'info', text: 'Please enter email', showCancelButton: false })
      } else {
        const getCaptchaRequest = { email: this.data.email }
        AuthApi.sendCaptcha(getCaptchaRequest, function (result) {
          $this.$swal({ type: 'success', text: 'Success to send captcha to your email address', showCancelButton: false })
          $this.passwordDisable = false
          $this.emailDisable = true
        }, function (result) {
          $this.$swal({ type: 'warning', text: result.message, showCancelButton: false })
        })
      }
    },
    save () {
      const $this = this
      if (this.data.password !== this.data.ensurePassword) {
        this.$swal({ type: 'warning', text: 'The two passwords you typed do not match.', showCancelButton: false })
      }
      const changePasswordRequest = { captcha: this.data.captcha, email: this.data.email, password: Crypto.md5(this.data.password) }
      AuthApi.resetPassword(changePasswordRequest, function (result) {
        cache.setAccessToken(result)
        $this.$swal({ type: 'success', text: 'Success to change password', showCancelButton: false }).then(res => {
          $this.hideDialog()
        })
      }, function (result) {
        $this.$swal({ type: 'warning', text: result.message, showCancelButton: false })
      })
    }
  }
}
</script>

<style scoped lang="css">
  .reset-email-code {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .reset-email-code button {
    margin: 0 10px;
    width: 20%;
  }
  .reset-email-code {
    width: 100%!important;
  }

</style>
